import React from 'react';
import dayjs from 'dayjs';

import { SiteConfigManager } from '@atlas/core';
import { HeaderTitle, Label, Loader, Pagination } from '@atlas/ui';

const PromoCodesList = ({
  changeCurrentPage,
  loading,
  paging: { currentPage, totalPages },
  promoCodes,
}) => {
  const dateFormat = SiteConfigManager.getConfig('config.config.date.dateFormat', 'DD.MM.YYYY');
  const timeFormat = SiteConfigManager.getConfig('config.config.date.timeFormat', 'HH:mm');

  if (loading) {
    return <Loader className="promo-codes-list__loader" />;
  }

  if (!promoCodes.length) {
    return <div className="promo-codes-list__empty" />;
  }

  return (
    <div className="promo-codes-list">
      <HeaderTitle
        className="sub-text block-medium promo-codes-list__header"
        title="promocode_history"
      />
      {promoCodes.map(({ code, createTime, id }) => (
        <div className="promo-codes-list__item" key={id}>
          <div className="promo-codes-list__item-code">
            <Label className="promo-codes-list__item-key" message="promocode" />
            <span className="promo-codes-list__item-value">{code}</span>
          </div>
          <div className="promo-codes-list__item-time">
            <Label className="promo-codes-list__item-key" message="promocode_used_time" />
            <span className="promo-codes-list__item-value">
              {dayjs(createTime).format(dateFormat)} {dayjs(createTime).format(timeFormat)}
            </span>
          </div>
        </div>
      ))}
      {totalPages > 1 && (
        <Pagination
          changeCurrentPage={changeCurrentPage}
          currentPage={currentPage}
          pages={totalPages}
          siblingCount={0}
        />
      )}
    </div>
  );
};

export default PromoCodesList;
